<mat-dialog-content>
  <lemon-dialog-header>Poistetaanko tositteesta luodut AI kirjaukset?</lemon-dialog-header>

  <div style="margin-top: 12px; line-height: 1.5">
    <p>Tämä poistaa kaikki kirjaukset, jotka tämän tositteen AI-luottokorttilaskuajo on luonut, ja palauttaa tositteen tilaan, jossa ajon voi tehdä uudelleen.</p>

    <p style="margin-top: 12px"><strong>Huom:</strong> jos joku kirjauksista on jo hyväksytty, kumousta ei tehdä. Pura hyväksyntä ensin ja yritä uudelleen.</p>

    <p style="margin-top: 8px">Tositetta itseään ei poisteta.</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (poista luottokorttilaskun luomat kirjaukset dialog)">Peruuta</app-secondary-button>
  <span style="display: inline-block; width: 8vw; max-width: 4em"></span>
  <app-primary-button (click)="poista()" actionId="Vahvista luottokorttilaskun luomien kirjausten poisto">Poista</app-primary-button>
</mat-dialog-actions>
